module.exports = __webpack_public_path__ + "static/img/home9.2a1a265e.png";